import { render, staticRenderFns } from "./DataSourceEditor.vue?vue&type=template&id=3db65592&"
import script from "./DataSourceEditor.vue?vue&type=script&lang=js&"
export * from "./DataSourceEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports